module.exports = __webpack_public_path__ + "images/7f189ec138e452ef97964d5996e81f69-IMG_6425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_6425.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_6425.jpg
// module chunks = 0